import { Message } from '@messageformat/react';
import { Col, Row, useLocale } from '@op/opds.opux';
import { IconPrevious } from '@op/opds.opux-icons/navigation';
import { space } from '@op/opds.tokens';
import { ReactElement } from 'react';
import { useParams } from 'react-router';
import { CourseNumber } from '../interfaces/CoursePage';
import { ReactComponent as MainImage } from '../images/main.svg';
import CourseMaterial from './CourseMaterial';
import CourseLinkBox from './CourseLinkBox';
import CourseNavigation from './CourseNavigation';
import { useIsMobile } from '../util/mediaQuery';
import {
  analyticsActionGroup,
  analyticsActionName,
  analyticsPhaseName,
  sendAnalyticsAction,
} from '../util/analytics';
import LinkButton from './LinkButton';
import routes from '../messages/routes';

const CourseWrapper = (): ReactElement => {
  const isMobile = useIsMobile();
  const params = useParams();
  const locale = useLocale();
  // force course number to be between 1 and 10, defaulting to 1
  const courseNumber = Math.max(
    Math.min(parseInt(params.courseNumber || '1', 10), 10),
    1,
  ) as CourseNumber;

  return (
    <div className="investoracademy-course-container">
      <Row>
        <Col xs={12}>
          <LinkButton
            icon={IconPrevious}
            compact
            to={routes[locale].courses}
            onClick={() => {
              sendAnalyticsAction(
                analyticsActionName.BACK_TO_COURSES,
                analyticsActionGroup.CLICK,
                analyticsPhaseName[courseNumber],
              );
            }}
            style={{ marginTop: space.small }}
          >
            {isMobile ? (
              <Message id="return_to_front_small" />
            ) : (
              <Message id="return_to_front" />
            )}
          </LinkButton>
        </Col>
        <Col
          xs={12}
          style={{ display: 'flex', alignItems: 'center', marginTop: space.large }}
        >
          <div style={{ display: 'block', margin: '0 auto' }}>
            <Row middle="xs" style={{ paddingBottom: space.default }}>
              <Col md={6} style={{ padding: 0 }}>
                <MainImage
                  style={{ width: '100%', maxHeight: '150px' }}
                  aria-hidden="true"
                />
              </Col>
              <Col md={6} style={{ padding: 0 }}>
                <div
                  aria-hidden="true"
                  style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
                  className="opds-styles-v1-text-hero-small"
                >
                  <Message id="investor_academy_title" />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <CourseMaterial showCourse={courseNumber} />
        </Col>
      </Row>

      <CourseNavigation fromCourseNumber={courseNumber} allowNext={courseNumber < 10} />

      <CourseLinkBox course={courseNumber} />
    </div>
  );
};

export default CourseWrapper;
